import BaseAdditionalExpenseRecord from "@/models/server/AdditionalExpenseRecords/BaseAdditionalExpenseRecord";

export default class ReturnInspectionAdditionalExpenseRecord extends BaseAdditionalExpenseRecord {
    public returnInspectionReportId: string = "";

    public returnInspectionReport: string | null = null;

    public stepId: string = "";

    public stepNumber: number = 0;

    public isReturnInspectionAdditionalExpenseRecord: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ReturnInspectionAdditionalExpenseRecord) || ((from as any).isReturnInspectionAdditionalExpenseRecord === true));
    }

    public static hasDuplicatedAdditionalExpenses(additionalExpenses: Readonly<ReturnInspectionAdditionalExpenseRecord[]>): boolean {
        const expenseInfo: [string, string][] = additionalExpenses
            .map(expense => [expense.name.toLowerCase().trim(), expense.stepId ?? null]);

        const duplicatesUnderSameStep: [string, string][] = expenseInfo
            .filter((expense, index, self) =>
                self.findIndex(e => e[0] === expense[0] && e[1] === expense[1]) !== index);

        return (duplicatesUnderSameStep.length > 0);
    }

    public static isAdditionalExpensesValid(additionalExpenses: Readonly<ReturnInspectionAdditionalExpenseRecord[]>): boolean {
        if (additionalExpenses == null || additionalExpenses.length == 0) {
            return true;
        }

        if (this.hasDuplicatedAdditionalExpenses(additionalExpenses)) {
            return false;
        }

        return additionalExpenses
            .every(expense => this.isValid(expense))
    }
}